import PropTypes from 'prop-types';
import SearchOption from '../../../shared/components/SearchOption/SearchOption';
import SearchOptionButton from '../../../shared/components/SearchOption/SearchOptionButton';
import { DateFieldOverlay, DateShape } from './DateFieldOverlay';

export const DateField = ({
  header,
  overlayTitle,
  submitLabel,
  onChange,
  isOpen,
  isOtherActive,
  onClose,
  availableDates,
  selected,
  dateFrom,
}) => {
  return (
    <>
      <SearchOption>
        <SearchOptionButton header={header} isOpen={isOpen} isOtherActive={isOtherActive}>
          {selected ? selected.display : ''}
        </SearchOptionButton>
      </SearchOption>
      <DateFieldOverlay
        isOpen={isOpen}
        onClose={onClose}
        onChange={onChange}
        title={overlayTitle}
        availableDates={availableDates}
        submitLabel={submitLabel}
        selected={selected}
        dateFrom={dateFrom}
      />
    </>
  );
};

DateField.propTypes = {
  header: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  selected: DateShape,
  availableDates: PropTypes.arrayOf(DateShape),
  dateFrom: DateShape,
  overlayTitle: PropTypes.node,
  submitLabel: PropTypes.node,
  isOpen: PropTypes.bool,
  isOtherActive: PropTypes.bool,
  onClose: PropTypes.func,
};
